module.exports = __webpack_public_path__ + "img/portal-proveedores.9aa0b1f4.svg";